import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid, TextField, Typography, Card, Button, Box, Modal } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import CodeInput from "components/CodeInput";
import { Close as CloseIcon } from "@mui/icons-material"; // red X icon
import "react-phone-number-input/style.css";
import {
  getUserProfile,
  updateUserProfile,
  resendEmailOTP,
  verifyEmailOTP,
  verifyPhoneOTP,
  resendPhoneOTP,
  updatePauseStatus,
  sendPermissionMail,
  deleteDistributor,
} from "service/axiosConfig";
import { toast } from "react-toastify";
import { useSearchParams, useNavigate } from "react-router-dom";
const verificationButtonStyle = {
  backgroundColor: "#561919",
  color: "#fff",
  border: "2px solid #561919",
  fontWeight: "bold",
  textTransform: "uppercase",
  padding: "12px",
  "&:hover": {
    backgroundColor: "#f5f5f5 !important",
    color: "#561919",
  },
  "&:disabled": {
    boxShadow: "none",
    color: "#561919 !important",
  },
  "& *": {
    color: "#561919 !important",
  },
};
// 👇 Customize input + label styles
const inputStyle = {
  border: "1px solid rgb(204, 204, 204)",
  borderRadius: "5px",
  height: "2.5rem",
  padding: "0 10px",
  width: "240px",
  outline: "none",
};

const labelStyle = {
  fontSize: "0.85rem",
  color: "#333",
  marginBottom: "4px",
};

export default function EditProfileScreen() {
  const navigate = useNavigate();
  const userId = parseInt(localStorage.getItem("userId"), 10);
  const [profileVersion, setProfileVersion] = useState(0);
  const relationshipOptions = [
    "Spouse",
    "Sibling",
    "Child",
    "Parent",
    "Friend",
    "Patient",
    "Other",
  ];

  const profileFields = [
    { label: "Name", field: "name", type: "text" },
    { label: "Phone Number", field: "phone", type: "phone", showNote: true },
    { label: "Email", field: "email", type: "email", showNote: true },
    { label: "Relationship (My...)", field: "relationship", type: "select" },
  ];
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const [verifiedStatus, setVerifiedStatus] = useState({
    email: false,
    phone: false,
  });
  const [userDistributationEmail, setUserDistributationEmail] = useState([{ email: "", name: "" }]);

  const [otpRequested, setOtpRequested] = useState({
    email: false,
    phone: false,
  });

  const [pendingFields, setPendingFields] = useState({
    email: false,
    phone: false,
  });

  const [caregiverProfile, setCaregiverProfile] = useState({
    name: "",
    phone: "",
    email: "",
    relationship: "",
  });

  const [wellcheckProfile, setWellcheckProfile] = useState({
    name: "",
    phone: "",
  });

  const [originalValues, setOriginalValues] = useState({
    email: "",
    phone: "",
  });

  const [formErrors, setFormErrors] = useState({
    email: "",
    phone: "",
    wellcheckPhone: "",
  });

  const statusMap = {
    1: { label: "Pending", color: "#FFC107" }, // amber
    2: { label: "Active", color: "#4CAF50" }, // green
    3: { label: "Denied", color: "#9E9E9E" }, // gray
    4: { label: "Unsubscribed", color: "#9E9E9E" }, // gray
    5: { label: "Expired", color: "#F44336" }, // red
    6: { label: "Paused", color: "#9E9E9E" }, // gray
  };
  const canToggleStatus = (s) => s === 2 || s === 6; // Active/Paused
  const nextStatus = (s) => (s === 2 ? 6 : 2);
  const toggleLabel = (s) => (s === 2 ? "Pause" : "Resume now");

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Link copied.");
    } catch {
      toast.error("Failed to copy link.");
    }
  };

  const [togglingId, setTogglingId] = useState(null);

  const onToggleStatus = async (item) => {
    try {
      var planStatus = localStorage.getItem("planStatus");
      if (planStatus.toLowerCase() === "expired") {
        toast.error("Your subscription has expired. Please upgrade to continue.");
        return;
      }
      if (planStatus.toLowerCase() === "noplan") {
        toast.error("Please select a Heartline plan to continue.");
        navigate("/plans"); // optional
        return;
      }
      const target = nextStatus(item.status);
      setTogglingId(item.email);

      await updatePauseStatus({
        userId: userId,
        email: item.email,
        status: target,
      });
    } finally {
      setTogglingId(null);
      setProfileVersion((v) => v + 1);
    }
  };
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleOpen = (item, index) => {
    if (!item.saved) {
      if (index === 0) {
        // first row → show toast instead of removing
        if (!item?.email || item.email.trim() === "") {
          toast.error("Please add recipient email first.");
          return;
        }

        // clear first row
        const updated = [...userDistributationEmail];
        updated[0] = { email: "", name: "", saved: false };
        setUserDistributationEmail(updated);
      } else {
        // other unsaved row → just remove
        setUserDistributationEmail(userDistributationEmail.filter((_, i) => i !== index));
      }
      return;
    }
    // saved row → show confirmation popup + API
    setSelected({ item, index });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelected(null);
  };

  const handleConfirmDelete = async () => {
    var planStatus = localStorage.getItem("planStatus");
    if (planStatus.toLowerCase() === "expired") {
      toast.error("Your subscription has expired. Please upgrade to continue.");
      return;
    }
    if (planStatus.toLowerCase() === "noplan") {
      toast.error("Please select a Heartline plan to continue.");
      navigate("/plans"); // optional
      return;
    }
    if (!selected) return;

    const { item, index } = selected;
    try {
      await deleteDistributor({
        userId,
        email: item.email,
      });

      const filtered = userDistributationEmail.filter((_, i) => i !== index);
      setUserDistributationEmail(filtered);
    } catch (err) {
      console.error("Delete failed:", err);
    } finally {
      handleClose();
      setProfileVersion((v) => v + 1); // 🔁 triggers re-fetch
    }
  };

  // Drop-in replacement for your current onReinvite
  const onReinvite = async (item) => {
    var planStatus = localStorage.getItem("planStatus");
    if (planStatus.toLowerCase() === "expired") {
      toast.error("Your subscription has expired. Please upgrade to continue.");
      return;
    }
    if (planStatus.toLowerCase() === "noplan") {
      toast.error("Please select a Heartline plan to continue.");
      navigate("/plans"); // optional
      return;
    }
    const { secondsLeft, remaining } = getInviteStats(item.email); // uses your helpers

    // Guards
    if (secondsLeft > 0) {
      toast.info(`Please wait ${secondsLeft}s before re-inviting.`);
      return;
    }
    if (remaining === 0) {
      toast.error("Daily limit reached (3 per 24h). Try later.");
      return;
    }

    setTogglingId(item.email);
    try {
      await sendPermissionMail({
        userId, // already defined in your scope
        email: item.email,
      });

      recordInviteSent(item.email); // log success locally
      setProfileVersion((v) => v + 1); // re-fetch via your versioned effect
    } finally {
      setTogglingId(null);
    }
  };

  // ---- Re-invite throttle helpers ----
  const REINVITE_LOG_KEY = "reinviteLog.v1";

  const loadLog = () => {
    try {
      return JSON.parse(localStorage.getItem(REINVITE_LOG_KEY) || "{}");
    } catch {
      return {};
    }
  };
  const saveLog = (log) => localStorage.setItem(REINVITE_LOG_KEY, JSON.stringify(log));

  const getInviteStats = (email) => {
    const now = Date.now();
    const dayAgo = now - 24 * 60 * 60 * 1000;
    const log = loadLog();
    const entries = (log[email] || []).filter((ts) => ts >= dayAgo);
    // prune old entries
    if ((log[email] || []).length !== entries.length) {
      log[email] = entries;
      saveLog(log);
    }
    const last = entries[entries.length - 1] || 0;
    const secondsLeft = last ? Math.max(0, 60 - Math.floor((now - last) / 1000)) : 0;
    const remaining = Math.max(0, 3 - entries.length); // quota left in last 24h
    return { secondsLeft, remaining };
  };

  const recordInviteSent = (email) => {
    const log = loadLog();
    const arr = log[email] || [];
    arr.push(Date.now());
    log[email] = arr;
    saveLog(log);
  };

  // tick every second to update countdown labels
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    const plan = localStorage.getItem("verifiedUserPlan");
    if (plan) {
      setUserPlan(parseInt(plan, 10));
    }
  }, []);

  const maxEmailEntries = userPlan === 3 || userPlan === 2 ? 5 : 0;

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const profile = await getUserProfile();
        // when setting from backend
        if (profile.userDistributationEmail?.length) {
          setUserDistributationEmail(
            profile.userDistributationEmail.map((e) => ({ ...e, saved: true }))
          );
        } else {
          setUserDistributationEmail([{ email: "", name: "", saved: false }]);
        }

        setCaregiverProfile({
          name: profile.profileName,
          phone: profile.profilePhone,
          email: profile.profileEmail,
          relationship: profile.profileRelationShip,
        });

        setWellcheckProfile({
          name: profile.wellCheckName,
          phone: profile.wellCheckPhone,
        });

        setOriginalValues({
          email: profile.profileEmail,
          phone: profile.profilePhone,
        });
      } catch (err) {
        toast.error("Failed to load profile.");
      }
    };

    fetchProfileData();
  }, [profileVersion]);
  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const lovedOneName = wellcheckProfile?.name || "your loved one";
  const annotatedEmails = (userDistributationEmail ?? []).map((e, _idx) => ({ ...e, _idx }));
  const visibleEmails = annotatedEmails.filter((e) => e?.email?.trim() || e?.name?.trim());
  const showEmptyState = visibleEmails.length === 0;

  const handleSave = async () => {
    var planStatus = localStorage.getItem("planStatus");
    if (planStatus.toLowerCase() === "noplan") {
      toast.error("Please select a Heartline plan to continue.");
      navigate("/plans"); // optional
      return;
    }
    if (planStatus.toLowerCase() === "expired") {
      toast.error("Your subscription has expired. Please upgrade to continue.");
      return;
    }
    let hasError = false;

    // Email Validation
    if (!caregiverProfile.email || !isValidEmail(caregiverProfile.email)) {
      setFormErrors((prev) => ({ ...prev, email: "Please enter a valid email address" }));
      hasError = true;
    } else {
      setFormErrors((prev) => ({ ...prev, email: "" }));
    }

    // Caregiver Phone Validation
    if (!caregiverProfile.phone || !isValidPhoneNumber(caregiverProfile.phone)) {
      setFormErrors((prev) => ({ ...prev, phone: "Please enter a valid phone number" }));
      hasError = true;
    } else {
      setFormErrors((prev) => ({ ...prev, phone: "" }));
    }

    // Wellcheck Phone Validation
    if (!wellcheckProfile.phone || !isValidPhoneNumber(wellcheckProfile.phone)) {
      setFormErrors((prev) => ({
        ...prev,
        wellcheckPhone: "Please enter a valid Wellcheck phone number",
      }));
      hasError = true;
    } else {
      setFormErrors((prev) => ({ ...prev, wellcheckPhone: "" }));
    }

    if (hasError) return;

    // Detect changes
    const emailChanged = caregiverProfile.email !== originalValues.email;
    const phoneChanged = caregiverProfile.phone !== originalValues.phone;
    //const wellcheckChanged = wellcheckProfile.phone !== originalValues.wellcheckPhone;

    // 🔁 Check if any changed fields are still unverified
    const needsVerification =
      (emailChanged && !verifiedStatus.email) || (phoneChanged && !verifiedStatus.phone);

    if (needsVerification) {
      setPendingFields({
        email: emailChanged && !verifiedStatus.email,
        phone: phoneChanged && !verifiedStatus.phone,
      });
      setShowVerificationModal(true);
      return;
    }
    const filteredEmails = userDistributationEmail.filter((e) => e.email.trim() || e.name.trim());

    // Email Distribution List Validation
    const emailSet = new Set();

    for (let i = 0; i < filteredEmails.length; i++) {
      const entry = filteredEmails[i];

      if (!entry.email || !isValidEmail(entry.email)) {
        toast.error(`Email Distribution #${i + 1} has an invalid email`);
        hasError = true;
        return;
      }

      if (!entry.name || entry.name.trim().length === 0) {
        toast.error(`Email Distribution #${i + 1} requires a name`);
        hasError = true;
        return;
      }

      const normalizedEmail = entry.email.trim().toLowerCase();
      if (emailSet.has(normalizedEmail)) {
        toast.error(`Email Distribution #${i + 1} is a duplicate email`);
        hasError = true;
        return;
      }

      emailSet.add(normalizedEmail);
    }

    // ✅ If verified or unchanged, save
    await updateUserProfile({
      userId,
      profileName: caregiverProfile.name,
      profileEmail: caregiverProfile.email,
      profilePhone: caregiverProfile.phone,
      profileRelationShip: caregiverProfile.relationship,
      wellCheckName: wellcheckProfile.name,
      wellCheckPhone: wellcheckProfile.phone,
      userDistributationEmail: filteredEmails,
    });

    // 🧠 Reset original values after successful update
    setOriginalValues({
      email: caregiverProfile.email,
      phone: caregiverProfile.phone,
    });

    // ✅ Also reset verification flags
    setVerifiedStatus({
      email: false,
      phone: false,
    });
    setOtpRequested({
      email: false,
      phone: false,
    });
    setProfileVersion((v) => v + 1); // 🔁 triggers re-fetch
  };

  const handleEmailCodeVerify = async (code) => {
    try {
      await verifyEmailOTP(caregiverProfile.email, code, true);
      setVerifiedStatus((prev) => {
        const updated = { ...prev, email: true };
        maybeCloseModal(updated);
        return updated;
      });
    } catch (err) {
      console.error("Email verification failed");
    }
  };

  const handlePhoneCodeVerify = async (code) => {
    try {
      await verifyPhoneOTP(caregiverProfile.email, caregiverProfile.phone, code, true);
      setVerifiedStatus((prev) => {
        const updated = { ...prev, phone: true };
        maybeCloseModal(updated);
        return updated;
      });
    } catch (err) {
      console.error("Phone verification failed");
    }
  };

  const handleWellcheckCodeVerify = async (code) => {
    try {
      await verifyPhoneOTP(caregiverProfile.email, wellcheckProfile.phone, code, true);
      setVerifiedStatus((prev) => {
        const updated = { ...prev, wellcheckPhone: true };
        maybeCloseModal(updated);
        return updated;
      });
    } catch (err) {
      console.error("Wellcheck phone verification failed");
    }
  };
  const maybeCloseModal = (status) => {
    const allDone = Object.keys(pendingFields).every((key) => !pendingFields[key] || status[key]);

    if (allDone) {
      setShowVerificationModal(false);
    }
  };

  return (
    <>
      {/* Header */}
      <header
        style={{
          backgroundColor: "#561919",
          color: "#fff",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        <div>
          <Link
            to="https://myheartline.com/"
            style={{
              fontWeight: "bold",
              fontSize: "1.25rem",
              color: "#fff",
              textDecoration: "underline",
            }}
          >
            Heartline
          </Link>
        </div>

        {/* <nav style={{ display: "flex", gap: "2rem" }}>
          <Link
            to="https://myheartline.com/contact/"
            style={{ textDecoration: "none", color: "#fff", fontWeight: "bold" }}
          >
            Contact
          </Link>
          <Link
            to="/authentication/demo"
            style={{ textDecoration: "none", color: "#fff", fontWeight: "bold" }}
          >
            Demo
          </Link>
        </nav> */}
      </header>

      {/* Body */}
      <DashboardLayout>
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                {/* Top Bar */}
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  bgColor="rgb(86,25,25)"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDBox display="flex" alignItems="center">
                    <AccountCircleIcon fontSize="medium" sx={{ color: "#fff" }} />
                    <MDTypography variant="h6" color="white" px={1}>
                      Edit Profile
                    </MDTypography>
                  </MDBox>

                  <DashboardNavbar />
                </MDBox>
                {/* Content */}
                <Box pt={3} px={2} pb={6}>
                  <Grid container spacing={4}>
                    {/* Left Column: My Profile + Wellcheck */}
                    <Grid item sm={12} md={6}>
                      {/* My Profile Section */}
                      <Box mb={5}>
                        <Typography
                          variant="subtitle2"
                          fontWeight="bold"
                          color="rgb(86,25,25)"
                          mb={2}
                        >
                          My Profile
                        </Typography>

                        {profileFields.map((item, idx) => (
                          <Grid container spacing={1} alignItems="center" mb={1.5} key={idx}>
                            <Grid item xs={12} sm={4}>
                              <Typography
                                sx={{
                                  fontSize: "0.75rem",
                                  fontWeight: 700,
                                  color: "#2F3E51",
                                  textTransform: "uppercase",
                                }}
                              >
                                {item.label}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={8}>
                              {item.type === "phone" ? (
                                <>
                                  <Box
                                    position="relative"
                                    width="100%"
                                    sx={{
                                      "& .PhoneInputInput, & .react-international-phone-input": {
                                        fontSize: "0.75rem",
                                      },
                                      width: "100%",
                                    }}
                                  >
                                    <PhoneInput
                                      value={caregiverProfile[item.field]}
                                      onChange={(val) =>
                                        setCaregiverProfile({
                                          ...caregiverProfile,
                                          [item.field]: val,
                                        })
                                      }
                                      defaultCountry="US"
                                      disableCountryPicker={false}
                                      international={false}
                                      addInternationalOption={false}
                                      countries={["US"]}
                                      disableArrowIcon
                                      style={{
                                        width: "100%",
                                        fontSize: "0.75rem",
                                        border: "1px solid rgb(204, 204, 204)",
                                      }}
                                    />

                                    {item.showNote && (
                                      <Tooltip title="Update requires verification" arrow>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "text.secondary",
                                          }}
                                        >
                                          <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {item.field === "phone" && formErrors.phone && (
                                      <Box mt={0.5}>
                                        <Typography variant="caption" color="error">
                                          {formErrors.phone}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </>
                              ) : item.type === "select" ? (
                                <Box
                                  sx={{
                                    "& > select": {
                                      fontSize: "0.75rem",
                                    },
                                    width: "100%",
                                  }}
                                >
                                  <select
                                    value={
                                      relationshipOptions.includes(caregiverProfile[item.field])
                                        ? caregiverProfile[item.field]
                                        : "Other"
                                    }
                                    onChange={(e) =>
                                      setCaregiverProfile({
                                        ...caregiverProfile,
                                        [item.field]: e.target.value,
                                      })
                                    }
                                    style={{ ...inputStyle, width: "100%", padding: "10px" }}
                                  >
                                    {relationshipOptions.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </Box>
                              ) : (
                                <>
                                  <Box
                                    position="relative"
                                    width="100%"
                                    sx={{
                                      "& > input": {
                                        fontSize: "0.75rem",
                                      },
                                      width: "100%",
                                    }}
                                  >
                                    <input
                                      type={item.type}
                                      value={caregiverProfile[item.field]}
                                      onChange={(e) =>
                                        setCaregiverProfile({
                                          ...caregiverProfile,
                                          [item.field]: e.target.value,
                                        })
                                      }
                                      style={{
                                        ...inputStyle,
                                        width: "100%",
                                      }}
                                    />

                                    {item.showNote && (
                                      <Tooltip title="Update requires verification" arrow>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "text.secondary",
                                          }}
                                        >
                                          <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {/* Error message */}
                                    {item.field === "email" && formErrors.email && (
                                      <Box mt={0.5}>
                                        <Typography variant="caption" color="error">
                                          {formErrors.email}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </>
                              )}
                            </Grid>
                          </Grid>
                        ))}
                      </Box>

                      {/* Wellcheck Profile Section */}
                      <Box mb={5}>
                        <Typography
                          variant="subtitle2"
                          fontWeight="bold"
                          color="rgb(86,25,25)"
                          mb={2}
                        >
                          Wellcheck Profile
                        </Typography>

                        {[
                          { label: "Name", field: "name", type: "text" },
                          { label: "Phone Number", field: "phone", type: "phone" },
                        ].map((item, idx) => (
                          <Grid container spacing={1} alignItems="center" mb={1.5} key={idx}>
                            <Grid item xs={12} sm={4}>
                              <Typography
                                sx={{
                                  fontSize: "0.75rem",
                                  fontWeight: 700,
                                  color: "#2F3E51",
                                  textTransform: "uppercase",
                                }}
                              >
                                {item.label}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                              {item.type === "phone" ? (
                                <>
                                  <Box
                                    sx={{
                                      "& .PhoneInputInput, & .react-international-phone-input": {
                                        fontSize: "0.75rem",
                                      },
                                      width: "100%",
                                    }}
                                  >
                                    <PhoneInput
                                      value={wellcheckProfile[item.field]}
                                      onChange={(val) =>
                                        setWellcheckProfile({
                                          ...wellcheckProfile,
                                          [item.field]: val,
                                        })
                                      }
                                      defaultCountry="US"
                                      countries={["US"]}
                                      disableArrowIcon
                                      disableCountryPicker={false}
                                      international={false}
                                      addInternationalOption={false}
                                      style={{
                                        width: "100%",
                                        border: "1px solid rgb(204, 204, 204)",
                                      }}
                                    />
                                    {formErrors.wellcheckPhone && (
                                      <Box mt={0.5}>
                                        <Typography variant="caption" color="error">
                                          {formErrors.wellcheckPhone}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </>
                              ) : (
                                <Box
                                  sx={{
                                    "& > input": {
                                      fontSize: "0.75rem",
                                    },
                                    width: "100%",
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={wellcheckProfile[item.field]}
                                    onChange={(e) =>
                                      setWellcheckProfile({
                                        ...wellcheckProfile,
                                        [item.field]: e.target.value,
                                      })
                                    }
                                    style={{ ...inputStyle, width: "100%" }}
                                  />
                                </Box>
                              )}
                            </Grid>
                          </Grid>
                        ))}
                      </Box>
                      <Box
                        mt={4}
                        sx={{
                          display: { xs: "none", md: "flex" },
                          justifyContent: "flex-start",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={handleSave}
                          sx={{
                            ...verificationButtonStyle,
                            width: { xs: "100%", sm: "240px" },
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                              color: "#561919",
                            },
                          }}
                        >
                          Save Changes
                        </Button>
                      </Box>
                    </Grid>
                    {/* Right Column: Email Distribution List */}
                    <Grid item sm={12} md={6} width={"100%"}>
                      <Box mb={5}>
                        <Typography
                          variant="subtitle2"
                          fontWeight="bold"
                          color="rgb(86,25,25)"
                          mb={2}
                        >
                          Email Distribution List
                        </Typography>
                        {/* Empty message */}
                        {/* Empty message */}
                        <Typography mb={3.5} sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
                          Create your care circle. Add people who should receive updates for{" "}
                          <span style={{ fontWeight: 700, color: "#2F3E51" }}>{lovedOneName}</span>.
                        </Typography>

                        {userDistributationEmail.map((item, index) => (
                          <React.Fragment key={index}>
                            {/* Email Row */}
                            <Grid container spacing={1} alignItems="center" mb={1.5}>
                              <Grid item xs={12} sm={4}>
                                <Typography
                                  sx={{
                                    fontSize: "0.75rem",
                                    fontWeight: 700,
                                    color: "#2F3E51",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  Email #{index + 1}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={8}>
                                <Box
                                  sx={{
                                    "& > input": {
                                      fontSize: "0.75rem",
                                    },
                                    width: "100%",
                                  }}
                                >
                                  <input
                                    type="email"
                                    placeholder="Enter email address"
                                    value={item.email}
                                    onMouseDown={(e) => {
                                      if (userPlan === 1 || userPlan === 0) {
                                        e.preventDefault();
                                        toast.error(
                                          "Upgrade your plan to edit the Email Distribution List."
                                        );
                                        return;
                                      }
                                    }}
                                    onChange={(e) => {
                                      const updated = [...userDistributationEmail];
                                      updated[index] = {
                                        ...updated[index],
                                        email: e.target.value,
                                        saved: updated[index].saved || false, // keep saved flag
                                      };
                                      setUserDistributationEmail(updated);
                                    }}
                                    style={{ ...inputStyle, width: "100%" }}
                                  />
                                </Box>
                              </Grid>
                            </Grid>

                            {/* Name Row */}
                            <Grid container spacing={1} alignItems="center" mb={1.5}>
                              <Grid item xs={12} sm={4}>
                                <Typography
                                  sx={{
                                    fontSize: "0.75rem",
                                    fontWeight: 700,
                                    color: "#2F3E51",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  Name
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={8}>
                                <Box
                                  sx={{
                                    "& > input": {
                                      fontSize: "0.75rem",
                                    },
                                    width: "100%",
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder="Enter name"
                                    value={item.name}
                                    onMouseDown={(e) => {
                                      if (userPlan === 1 || userPlan === 0) {
                                        e.preventDefault();
                                        toast.error(
                                          "Upgrade your plan to edit the Email Distribution List."
                                        );
                                        return;
                                      }
                                    }}
                                    onChange={(e) => {
                                      const updated = [...userDistributationEmail];
                                      updated[index].name = e.target.value;
                                      setUserDistributationEmail(updated);
                                    }}
                                    style={{ ...inputStyle, width: "100%" }}
                                  />
                                </Box>
                              </Grid>
                            </Grid>

                            {/* Status Badge Row (only if status exists in map) */}
                            {item.status && statusMap[item.status] && (
                              <Grid container spacing={1} alignItems="center" mb={1.5}>
                                {/* Left side: Label */}
                                <Grid item xs={12} sm={4}>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      fontWeight: 700,
                                      color: "#2F3E51",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Status
                                  </Typography>
                                </Grid>

                                {/* Right side: Badge + Actions */}
                                <Grid
                                  item
                                  xs={12}
                                  sm={8}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  {/* Badge */}
                                  <Box
                                    sx={{
                                      display: "inline-block",
                                      padding: "2px 8px",
                                      borderRadius: "6px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      height: "24px",
                                      backgroundColor: statusMap[item.status].color,
                                      color: "#fff",
                                    }}
                                  >
                                    {statusMap[item.status].label}
                                  </Box>

                                  {/* Right-aligned Actions */}
                                  <Box sx={{ display: "flex", gap: 1 }}>
                                    {/* Pause/Resume toggle */}
                                    {canToggleStatus(item.status) && (
                                      <Button
                                        size="small"
                                        variant="contained"
                                        onClick={() => onToggleStatus(item)}
                                        disabled={togglingId === (item.id ?? item.email)}
                                        sx={{
                                          ...verificationButtonStyle,
                                          textTransform: "none",
                                          fontWeight: 600,
                                          fontSize: "0.75rem",
                                          height: "18px",
                                          minWidth: "90px",
                                        }}
                                      >
                                        {togglingId === (item.id ?? item.email)
                                          ? "Updating..."
                                          : toggleLabel(item.status)}
                                      </Button>
                                    )}

                                    {/* Re-invite for Expired, Denied, Unsubscribed */}
                                    {[3, 4, 5].includes(item.status) &&
                                      (() => {
                                        const { secondsLeft, remaining } = getInviteStats(
                                          item.email
                                        );
                                        const isBusy = togglingId === (item.id ?? item.email);
                                        const disabled =
                                          isBusy || secondsLeft > 0 || remaining === 0;
                                        const label = isBusy
                                          ? "Sending..."
                                          : remaining === 0
                                          ? "Limit reached (24h)"
                                          : secondsLeft > 0
                                          ? `Re-invite in ${secondsLeft}s`
                                          : "Re-invite";

                                        return (
                                          <Button
                                            size="small"
                                            variant="contained"
                                            onClick={() => onReinvite(item)}
                                            disabled={disabled}
                                            sx={{
                                              ...verificationButtonStyle,
                                              textTransform: "none",
                                              fontWeight: 600,
                                              fontSize: "0.75rem",
                                              height: "18px",
                                              minWidth: "110px",
                                            }}
                                          >
                                            {label}
                                          </Button>
                                        );
                                      })()}

                                    {/* Copy link for Pending */}
                                    {/* {item.status === 1 && !!item.subscriptionLink && (
                                      <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => copyToClipboard(item.subscriptionLink)}
                                        sx={{
                                          textTransform: "none",
                                          fontWeight: 600,
                                          fontSize: "0.75rem",
                                          height: "18px",
                                          minWidth: "90px",
                                        }}
                                      >
                                        Copy link
                                      </Button>
                                    )} */}
                                  </Box>
                                </Grid>
                              </Grid>
                            )}

                            {/* Delete Row */}
                            {userDistributationEmail.length >= 1 && (
                              <Grid container spacing={1} alignItems="center" mb={3}>
                                <Grid item xs={12} sm={4} />
                                <Grid item xs={12} sm={8}>
                                  <IconButton
                                    onClick={() => handleOpen(item, index)}
                                    size="small"
                                    sx={{
                                      border: "2px solid",
                                      borderColor: "#561919",
                                      backgroundColor: "#561919",
                                      color: "#f5f5f5",
                                      borderRadius: "4px",
                                      px: 1,
                                      "&:hover": {
                                        backgroundColor: "#f5f5f5",
                                        color: "#561919",
                                      },
                                    }}
                                  >
                                    <CloseIcon sx={{ fontSize: "0.75rem !important", mr: 0.5 }} />
                                    <span style={{ fontSize: "0.75rem", fontWeight: 500 }}>
                                      Delete
                                    </span>
                                  </IconButton>
                                </Grid>
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}

                        {/* Add Button (respect max limit) */}
                        {userDistributationEmail.length < maxEmailEntries && (
                          <Button
                            onClick={() =>
                              setUserDistributationEmail([
                                ...userDistributationEmail,
                                { email: "", name: "" },
                              ])
                            }
                            sx={{
                              ...verificationButtonStyle,
                              width: { xs: "100px", sm: "auto" },
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                color: "#561919",
                              },
                              fontSize: { xs: "0.55rem", sm: "0.65rem", md: "0.65rem" },
                            }}
                          >
                            + Add Another
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Save Button */}
                  <Box mt={4} sx={{ display: { xs: "block", md: "none" } }}>
                    <Button
                      variant="contained"
                      onClick={handleSave}
                      sx={{
                        ...verificationButtonStyle,
                        width: { xs: "100%", sm: "240px" },
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                          color: "#561919",
                        },
                      }}
                    >
                      Save Changes
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
      {showVerificationModal && (
        <Modal
          open={showVerificationModal}
          onClose={() => {}} // disables outside click close
          disableBackdropClick // (for older MUI versions)
          disableEscapeKeyDown
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "#fff",
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              width: "100%",
              maxWidth: 600,
              position: "relative", // 🟡 Important for anchoring the close button
            }}
          >
            <Button
              onClick={() => setShowVerificationModal(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                minWidth: 32,
                height: 32,
                padding: 0,
                fontWeight: "bold",
                color: "#561919",
                backgroundColor: "#f5f5f5",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }}
            >
              X
            </Button>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Verification Needed Before Saving
            </Typography>
            <Typography variant="body1" gutterBottom>
              We noticed that you have updated your email or phone number. Please verify the new
              contact details below. Once verified, click the <strong>Save Changes</strong> button
              to complete the update.
            </Typography>

            {/* Email Section */}
            {pendingFields.email && (
              <Box mt={4}>
                <Typography>Email: {caregiverProfile.email}</Typography>
                {!verifiedStatus.email && (
                  <>
                    {!otpRequested.email ? (
                      <Button
                        sx={verificationButtonStyle}
                        onClick={async () => {
                          await resendEmailOTP(caregiverProfile.email);
                          setOtpRequested((prev) => ({ ...prev, email: true }));
                        }}
                      >
                        Send Verification Code
                      </Button>
                    ) : (
                      <>
                        {pendingFields.email && !verifiedStatus.email && (
                          <>
                            <Typography mt={2} fontWeight="600">
                              Enter Code:
                            </Typography>
                            <CodeInput onComplete={(code) => handleEmailCodeVerify(code)} />
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
                {verifiedStatus.email && (
                  <Typography mt={1} color="green">
                    ✅ Verified
                  </Typography>
                )}
              </Box>
            )}

            {/* Phone Section */}
            {pendingFields.phone && (
              <Box mt={4}>
                <Typography>Phone: {caregiverProfile.phone}</Typography>
                {!verifiedStatus.phone && (
                  <>
                    {!otpRequested.phone ? (
                      <Button
                        sx={verificationButtonStyle}
                        onClick={async () => {
                          await resendPhoneOTP(caregiverProfile.phone);
                          setOtpRequested((prev) => ({ ...prev, phone: true }));
                        }}
                      >
                        Send Verification Code
                      </Button>
                    ) : (
                      <>
                        {pendingFields.phone && !verifiedStatus.phone && (
                          <>
                            <Typography mt={2} fontWeight="600">
                              Enter Code:
                            </Typography>
                            <CodeInput onComplete={(code) => handlePhoneCodeVerify(code)} />
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
                {verifiedStatus.phone && (
                  <Typography mt={1} color="green">
                    ✅ Verified
                  </Typography>
                )}
              </Box>
            )}

            <Typography mt={4} fontSize={12} color="gray" textAlign="center">
              All codes are valid for 10 minutes. Please verify each before saving your profile.
            </Typography>
          </Box>
        </Modal>
      )}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: "#561919", fontWeight: "bold" }}>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to remove
            <strong> {selected?.item?.name || "Unnamed Recipient"} </strong>(
            <strong>{selected?.item?.email}</strong>) from your care circle?
            <br />
            <br />
            Once removed, this person will no longer receive updates or notifications. You can
            always add them back later if needed.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{
              border: "2px solid",
              borderColor: "#561919",
              backgroundColor: "#f5f5f5",
              color: "#561919",
              borderRadius: "4px",
              width: "100%",
              px: 1,
              "&:hover": {
                backgroundColor: "#e0e0e0", // subtle gray hover
                color: "#561919",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleConfirmDelete}
            sx={{
              border: "2px solid",
              borderColor: "#561919",
              backgroundColor: "#561919",
              color: "#f5f5f5",
              borderRadius: "4px",
              px: 1,
              width: "100%",
              "&:hover": {
                backgroundColor: "#8e1c1c", // deeper red to show danger
                color: "#ffffff",
              },
            }}
          >
            Confirm Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
